// extracted by mini-css-extract-plugin
export default {"restoran-container":"RestoranContainer_restoran-container__lV1fi","restoran-container--radios":"RestoranContainer_restoran-container--radios__JS8PG"};